"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Advanced = exports.Subtitle = exports.Title = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _truncate = _interopRequireDefault(require("lodash/truncate"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _head = _interopRequireDefault(require("lodash/head"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));

var Title = function Title(_ref) {
  var _name = _ref.name,
      emails = _ref.emails;
  var emailsNode = (0, _react.useMemo)(function () {
    var res = (0, _head["default"])(emails);

    if (!res) {
      return null;
    }

    if (res.length > 30) {
      res = res.replace(/([\s\S]{10})[\s\S]+([\s\S]{15})/, '$1...$2');
    }

    if (emails.slice(1).length > 0) {
      res += " +".concat(emails.length - 1, " others");
    }

    if (res.length > 30) {
      // $FlowFixMe
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-primary"
      }, {
        emails: res
      }); // $FlowFixMe
    } else return /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary"
    }, {
      emails: res
    });
  }, [emails]);
  var name = (0, _react.useMemo)(function () {
    return (0, _truncate["default"])(_name, {
      length: 15
    });
  }, [_name]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-2xl font-bold text-dark"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "dnd.drop.splitInbox.title",
    count: (0, _isNil["default"])(emailsNode) ? 1 : 2
  }, /*#__PURE__*/_react["default"].createElement("div", null), emailsNode, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, {
    name: name
  })));
};

exports.Title = Title;

var Subtitle = function Subtitle(_ref2) {
  var onClick = _ref2.onClick,
      isPlural = _ref2.isPlural;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: 400 + (isPlural ? 20 : 0)
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "dnd.drop.splitInbox.subtitle",
    count: isPlural ? 2 : 1
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('text-primary', {
      'hover:underline cursor-pointer': !!onClick
    }),
    onClick: onClick
  })));
};

exports.Subtitle = Subtitle;

var Advanced = function Advanced(_ref3) {
  var onClick = _ref3.onClick;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "text-xs text-gray-light flex items-center mx-auto font-bold hover:opacity-75",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
    fontSize: "small"
  }), "\xA0", /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "dnd.drop.splitInbox.advanced"
  }));
};

exports.Advanced = Advanced;
//# sourceMappingURL=SplitInbox.js.map